<template>
	<v-layout row wrap>
		<v-flex xs12 text-xs-left mb-2>
			<label class="label-title">Canal de Reserva</label>
		</v-flex>
		<v-flex xs12>
			<v-layout row wrap align-center>
				<v-flex xs4 md3 text-xs-left>
					<select-button
						autocomplete
						placeholder="Tipo de Canal"
						item-text="name"
						item-value="id"
						:items="typeChannels"
						v-model="channel.typeChannelId"
						@input="loadChannels"
					/>
					<span class="caption red--text"
						v-if="$v.channel.typeChannelId && $v.channel.typeChannelId.$invalid">
						El tipo de canal es requerido
					</span>
				</v-flex>
				<v-flex xs4 md3 text-xs-left>
					<select-button
						autocomplete
						placeholder="Canal"
						item-text="inputSearch"
						item-value="id"
						:items="channels"
						v-model="channel.channelSelected"
						@input="setChannelInfo"
					/>
					<span class="caption red--text"
						v-if="$v.channel.channelSelected && $v.channel.channelSelected.$invalid">
						El canal es requerido
					</span>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12>
			<v-layout row wrap mt-2>
				<v-flex xs4 md3
					v-for="(field, fieldIndex) in typeChannelSelected.fields"
					:key="fieldIndex"
					text-xs-left>
					<label class="label-form">{{ field.label }}</label>
					<component
						:is="field.type"
						:item-text="field.items.itemText"
						:item-value="field.items.itemValue"
						:items="field.items.name"
						:autocomplete="field.type === 'v-select'"
						:class="{ 'filter-select filter-select-autocomplete':
							field.type === 'v-select',
							'input-border-inset': field.type === 'v-text-field' }"
						v-model="field[field.value]">
					</component>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
import { required, minValue } from 'vuelidate/lib/validators';
import selectButton from '@/clerkinn/shared/select-button';
import inputText from '@/clerkinn/shared/input-text';
import lib from '@/shared/lib';

const { find, equality } = lib;

function created() {
	this.loadResources();
}

async function loadResources() {
	const requests = [
		this.$http.get(`${process.env.PMS_URL}/employees`),
		this.$http.get(`${process.env.PMS_URL}/channels`),
		this.$http.get(`${process.env.PMS_URL}/countries`),
	];
	const [
		{ data: employees },
		{ data: typeChannels },
		{ data: countries },
	] = await Promise.all(requests);
	this.employees = employees.data;
	this.typeChannels = typeChannels.data;
	this.countries = countries.data;
}

async function loadChannels(id) {
	const typeSelected = this.typeChannels.find(type => type.id === id);
	this.typeChannelSelected.id = id;
	if (typeSelected.inputInformations && (typeSelected.inputInformations.length > 0)) {
		this.typeChannelSelected.fields = typeSelected.inputInformations.map((input) => {
			const newInput = { ...input };
			newInput[input.value] = '';
			if (!input.items) {
				newInput.items = {};
			} else {
				newInput.items.name = Object.assign([], this[input.items.name]);
			}
			return newInput;
		});
	}
	const { data: channel } = await this.$http.get(`${process.env.PMS_URL}/channel-informations/${id}`);
	this.channels = channel.data;
	this.channel.channelSelected = 0;
	if (this.codeBooking) {
		this.channel.channelSelected = this.booking.channel ?
			this.booking.channel.data.channelsInformationId : 0;
	}
}

function setChannelInfo(id) {
	if (id > 0) {
		const channel = find(equality('id', id), this.channels);
		if (!this.codeBooking) {
			if (channel) {
				this.typeChannelSelected.fields = this.typeChannelSelected.fields.map((field) => {
					const newField = { ...field };
					newField[field.value] = channel.informations[field.value] || '';
					return newField;
				});
			}
		} else {
			const channelInformations = this.booking.channel ?
				this.booking.channel.data.questions : {};
			this.typeChannelSelected.fields = this.typeChannelSelected.fields.map((field) => {
				const newField = { ...field };
				newField[field.value] = channelInformations[field.value]
					|| channel.informations[field.value] || '';
				return newField;
			});
		}
	}
}

function trackingChannel(channelInfo) {
	this.$emit('channel-info', channelInfo, this.typeChannelSelected);
}

function invalidFunction(value) {
	this.$emit('invalid-channel-info', value);
}

function validations() {
	return {
		channel: {
			channelSelected: {
				required,
				minValue: minValue(1),
			},
			typeChannelId: {
				required,
				minValue: minValue(1),
			},
		},
	};
}

function data() {
	return {
		channel: {
			channelSelected: 0,
			typeChannelId: 0,
		},
		channels: [],
		countries: [],
		employees: [],
		typeChannels: [],
		typeChannelSelected: {
			id: 1,
			fields: [],
		},
	};
}

export default {
	name: 'channel-component',
	components: {
		inputText,
		selectButton,
	},
	created,
	data,
	methods: {
		invalidFunction,
		loadChannels,
		loadResources,
		setChannelInfo,
		trackingChannel,
	},
	props: {
		booking: {
			default: () => {},
			type: Object,
		},
		codeBooking: {
			default: '',
			type: String,
		},
	},
	validations,
	watch: {
		channel: {
			deep: true,
			handler: trackingChannel,
		},
		'$v.$invalid': invalidFunction,
	},
};
</script>




// WEBPACK FOOTER //
// ChannelComponent.vue?db5c0e2c